<template>
  <div class="vl-infotext-wrapper">
    <div class="vl-infotext">
      <div class="vl-infotext__value" data-vl-infotext-value>{{ animatedCount }}</div>
      <div class="vl-infotext__text">
        <!-- eslint-disable vue/no-v-html -->
        <p v-html="title"></p>
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue';

const props = defineProps({
  count: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  animate: {
    type: Boolean,
    required: false,
    default: true
  },
  animationDelay: {
    type: Number,
    default: 0 // Default delay is 0 milliseconds
  }
});

const animatedCount = ref(0);

const easeOutQuad = (t: number) => t * (2 - t);

const animateCount = (target: number, delay: number) => {
  const progressDuration = 500;

  setTimeout(() => {
    const startTime = performance.now();

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / progressDuration, 1);
      const easedProgress = easeOutQuad(progress);
      animatedCount.value = Math.floor(easedProgress * target);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, delay);
};

watch(
  () => props.count,
  (newCount) => {
    animateCount(newCount, props.animationDelay);
  }
);

onMounted(() => {
  if (props.animate) {
    animateCount(props.count, props.animationDelay);
  } else {
    animatedCount.value = props.count;
  }
});
</script>

<style lang="scss" scoped></style>
